module.exports = __webpack_public_path__ + "static/CCQ_Carvao_Saneamento-9d77e9a66a4cbf26cc24efffff8036c1.jpg";